import { render, staticRenderFns } from "./WrongEmail.vue?vue&type=template&id=60176928"
import script from "./WrongEmail.vue?vue&type=script&lang=js"
export * from "./WrongEmail.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports